module.exports = __webpack_public_path__ + "static/media/web.d518ae5d.config";